



































import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Watch,
  Vue
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import TextScroll from "@/views/vipCenter/vipButton/TextScroll.vue";
import VipOfferUtils from "@/utils/vipOfferUtils";
import * as types from "@/store/constants/types";
import * as AppLifeCycle from "@/utils/appLifeCycle";
import { isIos } from "@/utils/lodash";
import { routerStackModule } from "@/utils/routerStackUtil";

@Component({
  components: {
    TextScroll
  }
})
export default class VipButton extends Vue {
  @Getter(types.GETTER_VIP_OFFERS)
  private vipOffers: any;

  @Action(types.SHAKE_PLAY)
  private shakePlay: any;

  @Getter(types.GETTER_STATE_FRONT)
  private stateFront: any;

  @Prop({ default: 30000 })
  private countTime?: number;

  @Prop({ default: false })
  private needScrollText!: boolean;

  @Prop({ default: false })
  private needShorten!: boolean;

  @Prop({ default: true })
  private needShake!: boolean;

  @Prop({ default: undefined })
  private offer!: any;

  private timer?: any;
  private shakeDelay?: any;
  private counter: number = 0;
  private shake_class: string = "";
  private listenKeyStr: string = "vipButtonPlanB";

  get currentOffer() {
    return this.offer ? this.offer : this.vipOffers[this.vipOffers.length - 1];
  }

  get animationStyle() {
    return this.needShorten
      ? { animation: "shorten " + this.countTime + "ms linear" }
      : {};
  }

  get mode() {
    return this.needScrollText ? "small" : "large";
  }

  get peopleNumber() {
    return this.randomNumer(1000, 2000);
  }

  get changcesLeftNumber() {
    return this.randomNumer(50, 100);
  }

  get mainStr() {
    return this.buttonContents.main;
  }

  get subStr() {
    return this.buttonContents.sub;
  }

  get bonusStr() {
    return this.buttonContents.bonus;
  }

  get buttonContents() {
    const {
      iap = {},
      subscription = {},
      discount,
      is_no_auto_renew
    } = this.currentOffer;
    const { period, period_type } = subscription;

    const isFirst =
      (period_type === "month" || period_type === "week") && period === 1;

    if (is_no_auto_renew) {
      return isFirst
        ? { main: "FREE", sub: "BUY 1 mo", bonus: "GET 1 mo" }
        : { main: "CONTINUE" };
    } else {
      return isFirst ? { main: "TRY FOR FREE" } : { main: "CONTINUE" };
    }
  }

  get scrollList() {
    const list = [
      [this.peopleNumber, "&nbsppeople have upgraded today"],
      ["Only&nbsp", this.changcesLeftNumber, "&nbspfree chances left"]
    ];
    if (this.needShorten && this.counter) {
      list.push([this.counter, "s left"]);
    }
    return list;
  }

  private randomNumer(max: number, min: number) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  private clickButton() {
    this.clearState();
    this.$emit("click");
  }

  private initData() {
    if (this.needShorten && this.countTime && this.countTime > 0) {
      this.counter = Math.floor(this.countTime / 1000);
      this.timer = setInterval(() => {
        this.counter = this.counter - 2;
        if (this.counter <= 0) {
          clearInterval(this.timer);
          this.$emit("timeout");
        }
      }, 2000);
    }

    AppLifeCycle.addGoBackListener({
      key: this.listenKeyStr,
      fn: async () => {
        this.clearState();
      }
    });

    AppLifeCycle.addListener({
      key: this.listenKeyStr,
      fn: async () => {
        if (this.counter > 0) {
          this.clearState();
          this.initShakeState();
        }
      }
    });
    this.stateFront && this.initShakeState();
  }

  private mounted() {
    this.initData();
  }

  private activated() {
    this.initData();
  }

  private beforeDestroy() {
    this.clearState();
    AppLifeCycle.removeListener(this.listenKeyStr);
    AppLifeCycle.removeGoBackListener(this.listenKeyStr);
  }

  private clearState() {
    clearInterval(this.timer);
    clearTimeout(this.shakeDelay);
    this.shake_class = "";
  }

  private initShakeState() {
    this.shake_class = "shake";
    this.shakeDelay = setTimeout(() => {
      this.shakePlay(20, 0);
    }, 1200);
  }

  private deactivated() {
    this.clearState();
    AppLifeCycle.removeListener(this.listenKeyStr);
    AppLifeCycle.removeGoBackListener(this.listenKeyStr);
  }

  private renderScrollItem(item: any) {
    let htmlStr = "";
    for (const i of item.values()) {
      if (typeof i === "number") {
        htmlStr += `<p class='high'>${i}</p>`;
      } else {
        htmlStr += `<p class='normal'>${i}</p>`;
      }
    }
    return htmlStr;
  }
}
